var _circle, _circle2, _rect, _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgTax(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 26,
    height: 26,
    viewBox: "0 0 26 26",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 13,
    cy: 13,
    r: 13,
    fill: "black",
    fillOpacity: 0.12
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 13,
    cy: 13,
    r: 12,
    fill: "#39BAB5"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask0_9517_83265",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 4,
    y: 4,
    width: 18,
    height: 18
  }, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 4,
    y: 4,
    width: 18,
    height: 18,
    fill: "#C4C4C4"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_9517_83265)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M16 14.125C16.325 14.125 16.5938 14.0187 16.8063 13.8062C17.0188 13.5937 17.125 13.325 17.125 13C17.125 12.675 17.0188 12.4063 16.8063 12.1938C16.5938 11.9813 16.325 11.875 16 11.875C15.675 11.875 15.4063 11.9813 15.1938 12.1938C14.9813 12.4063 14.875 12.675 14.875 13C14.875 13.325 14.9813 13.5937 15.1938 13.8062C15.4063 14.0187 15.675 14.125 16 14.125ZM13.75 16.75C13.3375 16.75 12.9845 16.6033 12.691 16.3098C12.397 16.0158 12.25 15.6625 12.25 15.25V10.75C12.25 10.3375 12.397 9.98425 12.691 9.69025C12.9845 9.39675 13.3375 9.25 13.75 9.25H19C19.4125 9.25 19.7658 9.39675 20.0598 9.69025C20.3533 9.98425 20.5 10.3375 20.5 10.75V15.25C20.5 15.6625 20.3533 16.0158 20.0598 16.3098C19.7658 16.6033 19.4125 16.75 19 16.75H13.75ZM7.75 19.75C7.3375 19.75 6.98425 19.6033 6.69025 19.3098C6.39675 19.0158 6.25 18.6625 6.25 18.25V7.75C6.25 7.3375 6.39675 6.98425 6.69025 6.69025C6.98425 6.39675 7.3375 6.25 7.75 6.25H18.25C18.6625 6.25 19.0158 6.39675 19.3098 6.69025C19.6033 6.98425 19.75 7.3375 19.75 7.75H13.75C12.8625 7.75 12.1407 8.028 11.5847 8.584C11.0282 9.1405 10.75 9.8625 10.75 10.75V15.25C10.75 16.1375 11.0282 16.8592 11.5847 17.4152C12.1407 17.9717 12.8625 18.25 13.75 18.25H19.75C19.75 18.6625 19.6033 19.0158 19.3098 19.3098C19.0158 19.6033 18.6625 19.75 18.25 19.75H7.75Z",
    fill: "white"
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgTax);
export default __webpack_public_path__ + "static/media/tax.3b9e444f97495d3508766b23357d1c09.svg";
export { ForwardRef as ReactComponent };